import { createSlice } from "@reduxjs/toolkit";
import { fetchVitalPatients, savePatientVitals } from "../../apis/dispense/vitalPatients";
import {
	markPatientPrescriptionsPharmacistSigned,
	patchPatientPrescriptionsPharmacistSignedState,
} from "./pharmacistPrescriptionSignature";

const initialState = {
	loading: false,
	data: [],
	error: null,
	currentPage: 1,
	totalPages: null,
	saveVitals: {
		loading: false,
		error: null,
		success: false,
	},
}

const vitalPatientsSlice = createSlice({
	name: 'vitalPatients',
	initialState,

	reducers: {
        removeVitalPatientById(state, action) {
            const vitalPatientIdToRemove = action.payload;
            state.data = state.data.filter(item => item.id !== vitalPatientIdToRemove);
        },
		clearData(state) {
			state.data = []
		},
		removingPageNumber(state) {
			state.currentPage = 1
		}
	},

	extraReducers: (builder) => {
		builder.addCase(fetchVitalPatients.pending.type, (state, action) => {
			const isPageOne = action.meta?.arg?.page === 1;
			return {
				...state,
				loading: true,
				error: null,
				data: isPageOne ? [] : state.data,
			}
		})
		builder.addCase(fetchVitalPatients.fulfilled.type, (state, action) => {
			const isPageOne = action.payload.meta.current_page === 1;
			
			if (isPageOne) {
				return {
					...state,
					loading: false,
					data: action.payload.data || [],
					currentPage: action.payload.meta.current_page,
					totalPages: action.payload.meta.last_page,
					error: null,
				};
			} else {
				const existingIds = new Set(state?.data?.map(item => item.id));
				const newData = action?.payload?.data?.filter(item => !existingIds.has(item.id));

				return {
					...state,
					loading: false,
					data: [...state.data, ...newData],
					currentPage: action.payload.meta.current_page,
					totalPages: action.payload.meta.last_page,
					error: null
				};
			}
		});

		builder.addCase(fetchVitalPatients.rejected.type, (state, action) => {
			return {
				...state,
				loading: false,
				error: action.payload,
				data: []
			}
		})

		// Save Patient Vitals reducers
		builder.addCase(savePatientVitals.pending.type, (state) => {
			return {
				...state,
				saveVitals: {
					loading: true,
					error: null,
					success: false,
				}
			}
		})
		builder.addCase(savePatientVitals.fulfilled.type, (state, action) => {
			return {
				...state,
				saveVitals: {
					loading: false,
					error: null,
					success: true,
				}
			}
		});
		builder.addCase(savePatientVitals.rejected.type, (state, action) => {
			return {
				...state,
				saveVitals: {
					loading: false,
					error: action.payload,
					success: false,
				}
			}
		})
		builder.addCase(markPatientPrescriptionsPharmacistSigned, (state, action) => {
			patchPatientPrescriptionsPharmacistSignedState(state, action.payload);
		})
	}

})

export const { clearData, removingPageNumber, removeVitalPatientById } = vitalPatientsSlice.actions;

export default vitalPatientsSlice.reducer;
